import { C } from "@/brand/tokens";
import { FieldLabel } from "./FieldLabel";
import { fieldBase, fieldStyle, applyFocus, applyBlur } from "./fieldStyles";

export function FormTextarea({
  label,
  name,
  hint,
  required,
  index,
  testId,
}) {
  return (
    <div>
      <FieldLabel htmlFor={name} required={required} index={index}>
        {label}
      </FieldLabel>
      <textarea
        id={name}
        name={name}
        rows={4}
        required={required}
        data-testid={testId}
        maxLength={500}
        className={`${fieldBase} resize-y min-h-[120px]`}
        style={fieldStyle}
        onFocus={applyFocus}
        onBlur={applyBlur}
      />
      {hint && (
        <p
          className="mt-3 font-inter text-[12px] leading-[1.6]"
          style={{ color: C.inkOnLightSoft, maxWidth: "52ch" }}
        >
          {hint}
        </p>
      )}
    </div>
  );
}
